import { render, staticRenderFns } from "./BigMenu.vue?vue&type=template&id=f54fc5ac&scoped=true&"
import script from "./BigMenu.vue?vue&type=script&lang=js&"
export * from "./BigMenu.vue?vue&type=script&lang=js&"
import style0 from "./BigMenu.vue?vue&type=style&index=0&id=f54fc5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54fc5ac",
  null
  
)

export default component.exports